import styled from "styled-components";

const HistoryWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

const ItemWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
	gap: 10px;
`;

export { HistoryWrapper, ItemWrapper };
